module.exports = __webpack_public_path__ + "img/index_star.f96c7270.png";